import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-turnstile',
  templateUrl: './turnstile.component.html',
  styleUrls: ['./turnstile.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TurnstileComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() siteKey: string;
  @Output() tokenResolved = new EventEmitter<string>();

  public token: string | undefined;
  private turnstileWidgetId: string;
  private turnstileCallback = (token: string) => {
    this.token = token;
    this.tokenResolved.emit(token);
  };

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    // Ensure Turnstile script is loaded
    this.loadTurnstileScript();
  }

  ngAfterViewInit(): void {
    // Render the Turnstile widget after the view is initialized
    this.renderTurnstile();
  }

  ngOnDestroy(): void {
    if (this.turnstileWidgetId && window.turnstile) {
      window.turnstile.remove(this.turnstileWidgetId);
    }
  }

  private loadTurnstileScript(): void {
    // Check if Turnstile script is already loaded
    if (!document.getElementById('cf-turnstile-script')) {
      const script = document.createElement('script');
      script.id = 'cf-turnstile-script';
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  private renderTurnstile(): void {
    // Wait for Turnstile to be loaded
    const checkTurnstileLoaded = setInterval(() => {
      if (window.turnstile) {
        clearInterval(checkTurnstileLoaded);

        // Render the widget
        this.turnstileWidgetId = window.turnstile.render(document.getElementById('turnstile-container'), {
          sitekey: this.siteKey,
          callback: this.turnstileCallback,
          theme: 'light',
          language: 'en',
          size: 'flexible',
        });
      }
    }, 100);
  }
}

declare global {
  interface Window {
    turnstile: {
      render: (container: HTMLElement | string, options: any) => string;
      reset: (turnstileWidgetId: string) => void;
      remove: (turnstileWidgetId: string) => void;
    };
  }
}
